import React, { useEffect } from 'react';
import { View } from "react-native"
import { useDispatch, useSelector } from 'react-redux';
import { social_createPostReaction, social_getReactionsByPostIdAndPlayerId, social_getReactionStatsByPostId, social_updatePostComment, social_updatePostReaction } from '../../../store/actionsv1/social';
import { PublicPlayerProps } from '../../../store/types/auth_svc';
import { PostCommentProps, PostReactionProps, PostReactionStatsProps } from "../../../store/types/soc_svc"
import FormattedTextViewer from './FormattedTextViewer';
import MediaHolder from './MediaHolder';
import OrderHolder from './OrderHolder';
import PostCardHeader from './PostCardHeader';
import PostReactionBar from './PostReactionBar';
import URLPreviewCard from './URLPreviewCard';

type PostCommentCardProps = {
    post_comment: PostCommentProps,
    comment_width:number
}

const PostCommentCard = ({ post_comment, comment_width }:PostCommentCardProps) => {
    const dispatch = useDispatch();
    const player: PublicPlayerProps = useSelector((state:any) => state.player.player, (left, right) => left.player_id == right.player_id)
    const post_reaction_stats:PostReactionStatsProps[] = useSelector((state:any) => state.social.post_reaction_stats.filter((prs:PostReactionStatsProps) => prs.activity_post_id == post_comment.post_comment_id), (left, right) => {
        if(JSON.stringify(left) != JSON.stringify(right)){ return false }
        return true
    })
    const my_post_reactions:PostReactionProps[] = useSelector((state:any) => state.social.my_post_reactions.filter((pr:PostReactionProps) => pr.activity_post_id == post_comment.post_comment_id && pr.post_type === 'comment' && pr.status === 'visible'), (left, right) => left.length == right.length)

    useEffect(() => {
        getReactionStatsFromServer(post_comment.post_comment_id, 'comment')
    },[])

    const getReactionStatsFromServer = async(post_id:string, post_type:string) => {
        await dispatch(social_getReactionStatsByPostId(post_id, post_type))
        await dispatch(social_getReactionsByPostIdAndPlayerId(player.player_id, post_id, post_type))
    }

    const handleReaction = async(reaction:string) => {
        let existing_reaction = my_post_reactions.find(pr => pr.reaction === reaction)
        if(existing_reaction){ return await dispatch(social_updatePostReaction({ ...existing_reaction, status: existing_reaction.status === 'visible' ? 'hidden' : 'visible' })) }
        let pr:PostReactionProps = {
            post_reaction_id: '',
            activity_post_id: post_comment.post_comment_id,
            post_type: 'comment',
            player_id: player.player_id,
            create_datetime: '',
            last_update_datetime: '',
            reaction,
            status: 'visible'
        }
        await dispatch(social_createPostReaction(pr))
    }

    const handleAction = async(action:string) => {
        switch(action){
            case 'delete':
                return await dispatch(social_updatePostComment({ ...post_comment, status: 'hidden' }))
        }
    }
    
    let media_size = 0
    if(post_comment.comment_images){ media_size += post_comment.comment_images.length }
    if(post_comment.comment_videos){ media_size += post_comment.comment_videos.length }

    if(post_comment.status === 'hidden'){ return <></> }
    return (
        <View style={{ padding:10 }}>
            {post_comment.playerDetails ?
                <PostCardHeader create_datetime={post_comment.create_datetime} post_id={`C${post_comment.post_comment_id}`} viewer_id={player?.player_id} player={post_comment.playerDetails} onActionPress={(action) => handleAction(action)}/>
            :<></>}
            
            <View style={{ marginTop:9, marginBottom:4 }} nativeID='post_comment_formatted_body'>
                <FormattedTextViewer post_id={post_comment.post_comment_id} formatted_body={post_comment.formatted_body} text_fallback={post_comment.message} view_type='comment'/>
            </View>
            <View nativeID='post-media'>
                {media_size > 0 ?
                <MediaHolder width={comment_width} view_mode='view' images={post_comment.comment_images??[]} videos={post_comment.comment_videos??[]}/>
                :<></>}
                {post_comment.comment_orders && post_comment.comment_orders.length > 0 ?
                <OrderHolder view_mode='view' width={comment_width} order_ids={post_comment.comment_orders} />
                :<></>}
                {post_comment.comment_urls && post_comment.comment_urls.length > 0 && post_comment.url_metadata ?
                <URLPreviewCard view_mode='view' hide_image={media_size>0 || (post_comment.comment_orders && post_comment.comment_orders.length >0)?true:false} url_preview={post_comment.url_metadata[0]} url={post_comment.comment_urls[0]} width={comment_width}/>
                :<></>}
            </View> 
            <View nativeID='post_reaction'>
                <PostReactionBar my_post_reactions={my_post_reactions} post_reaction_stats={post_reaction_stats} onReactionSelect={(reaction) => handleReaction(reaction)}/>
            </View>
        </View>
    )
}

export default PostCommentCard